import React from "react";

import StyledSvgSprite from "@/components/Atoms/SVGSprite";
import { Typography } from "@/foundation/Typography/V2";
import theme from "@/foundation/Theme";

import {
  ChannelLogo,
  OverlayContent,
  StyledAction,
  StyledButton,
  StyledWebinarVideoOverlay,
  VideoMetadata,
  VideoTitle,
  VideoText,
} from "./style";

const WebinarVideoOverlay = ({
  thumbnail,
  channelLogo,
  videoTitle,
  buttonText,
  videoDuration,
  date,
  onCLickHandler,
}: any) => {
  return (
    <StyledWebinarVideoOverlay
      className="videoOverlay"
      bgImg={thumbnail && `url(${thumbnail})`}
    >
      <OverlayContent>
        {videoTitle && (
          <VideoTitle>
            <ChannelLogo
              src={channelLogo}
              height="32px"
              width="32px"
              flexDirection="row"
            />
            <VideoText variant="heading6" color={theme.colors.white}>
              {videoTitle}
            </VideoText>
          </VideoTitle>
        )}
        <StyledAction>
          <StyledButton
            bgColor={theme.colors.white}
            hoverColor={theme.colors.white}
            variant="primary1"
            fontFamily={"var(--man-700)"}
            btnPadding={"11px 16px 11px"}
            fontSize={["12px", "13px", "14px"]}
            version={"v2"}
            TextColor={theme.colorsV2.shyft.purple_text}
            primaryBorderColor={theme.colors.white}
            onClick={onCLickHandler}
          >
            <StyledSvgSprite
              icon="icon-play-webinar"
              fill={theme.colorsV2.shyft.purple_text}
              height="16px"
              width="16px"
              mr="10px"
            />
            {buttonText}
          </StyledButton>
        </StyledAction>
        {(videoDuration || date) && (
          <VideoMetadata>
            {videoDuration && (
              <Typography
                variant="label3"
                color={theme.colors.white}
                className="duration"
              >
                {videoDuration}
              </Typography>
            )}
            {date && (
              <Typography variant="label3" color={theme.colors.white}>
                {date}
              </Typography>
            )}
          </VideoMetadata>
        )}
      </OverlayContent>
    </StyledWebinarVideoOverlay>
  );
};

export default WebinarVideoOverlay;
